<!-- 支付组件 -->
<template>
    <div class='container'>
        <el-dialog @close="close" destroy-on-close :close-on-click-modal="false" width="15%" :visible.sync="innerVisible"
            append-to-body>
            <div class="saoPrice">
                <p class="p1">{{ types + "扫码" }}</p>
                <div style="margin: 0.2rem 0;">
                    <Qr :size="150" :text="wxText"></Qr>
                </div>
                <p class="p2">支付即同意<span>{{ types }}用户协议</span></p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PayApi from '@/components/Api/pay.js'
import Qr from '@/components/Qr'
export default {
    components: {
        Qr
    },
    props: {
        payPrice: {
            type: Number,
            default: 0
        },
        types: {
            type: String,
            default: '微信'
        },
        orderMainId: {
            type: String,
            default: ''
        },
        routeData: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            time: null, //定义setInterval的定时器名称
            setTime: null, //定义setTimeout的定时器名称
            innerVisible: false,
            wxText: '',
        }
    },
    computed: {},
    watch: {},
    beforeDestroy() {
        clearInterval(this.time)
        clearTimeout(this.setTime)
        this.time = null
        this.setTime = null
    },
    methods: {
        //清除定时器
        clearTimer() {
            clearInterval(this.time)
            clearTimeout(this.setTime)
            this.innerVisible = false
            this.time = null
            this.setTime = null
        },
        close() {
            this.setTime = setTimeout(() => {
                this.clearTimer()
                this.innerVisible = false
            }, 0)
        },
        handlerSelectPriceClick() {
            console.log(this.types, '开始空调开的快');
            if (this.payPrice > 0) {
                const h = this.$createElement;
                this.$msgbox({
                    title: "充值",
                    message: h("p", null, [
                        h("span", null, "本次充值金额为： "),
                        h(
                            "span", { style: "fontSize:0.22rem;color:red;fontWeight:bold" }, this.payPrice + "¥"
                        ),
                    ]),
                    showCancelButton: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            if (this.types === '微信') {
                                new PayApi('pay').codyOrderPayParameter({ orderMainId: this.orderMainId }).then((res) => {
                                    console.log(res, '看看返回的数据');
                                    if (res.status === 200) {
                                        let obj = {
                                            total_fee: Number(this.payPrice) * 100,
                                            body: res.data.body,//类型
                                            out_trade_no: res.data.outTradeNo,//标识
                                            attach: res.data.attach,
                                        }
                                        console.log(obj, '快乐时刻打开打开');
                                        new PayApi('pay').codePay(obj).then((res1) => {
                                            if (res1.status === 200) {
                                                this.wxText = res1.data
                                                this.innerVisible = true;
                                                this.time = setInterval(() => {
                                                    // 判断是否支付成功
                                                    new PayApi('pay').queryOrder({ transactionId: '', outTradeNo: res.data.outTradeNo }).then((res2) => {
                                                        console.log(res, '看看轮训放回的数据');
                                                        if (res2.data.trade_state == 'SUCCESS') {
                                                            this.wxText = ''
                                                            this.time && this.clearTimer() //清除定时器
                                                            this.innerVisible = false
                                                            this.$message.success('支付成功');
                                                            this.$emit('updatePrice')
                                                        }
                                                        if (res2.data.trade_state == 'RAYERRQR') {
                                                            this.setTime = setTimeout(() => {
                                                                this.clearTimer()
                                                                this.innerVisible = false
                                                            }, 0)
                                                        }
                                                    })
                                                }, 3000)
                                            }
                                        })
                                    }
                                })
                            } else {
                                this.$emit('updatePrice')
                                let url = window.location.href.indexOf('?') === -1 ? window.location.href : window.location.href.split('?')[0]
                                if(this.routeData) {
                                    url = url + this.routeData
                                }  
                                console.log(this.routeData,'开始空调开的快递');
                                let obj = {
                                    returnUrl: url,
                                    orderMainId: this.orderMainId,
                                }
                                new PayApi('pay').codyAliPayOrderParameter(obj).then((res) => {
                                    if (res.status === 200) {
                                        let obj1 = {
                                            subject: res.data.body,
                                            body: res.data.body,  
                                            passbackParams: res.data.outTradeNo,
                                            totalAmount: Number(this.payPrice),
                                            outTradeNo: res.data.outTradeNo,
                                        }
                                        window.open(new PayApi('pay').pcPay(obj1), '_self');
                                    }
                                })
                            }
                            done();
                        } else {
                            done();
                        }
                    },
                });
            } else {
                this.$message({
                    type: "warning",
                    message: "请选择或输入充值金额！",
                });
            }
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.saoPrice {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0.2rem;

    .p2 {
        font-size: 0.1rem;

        span {
            color: #3571f6;
        }
    }
}
</style>